import { atom } from "jotai";
import { isEqual } from "lodash";

import { getStartSlotIdFromCourt } from "../../../components/EditableRoundsStep/components/BookingDurationCourt/atoms/selectors/getStartSlotIdFromCourt";
import { currentBookingAtom, originalBookingAtom } from "../../stores";
import { getBookingDurationAtom } from "../getBookingDurationAtom/getBookingDurationAtom";

/**
 * Returns whether there are any unsaved changes in the edit booking modal
 */
export const isFormDirtyAtom = atom((get) => {
  const originalBooking = get(originalBookingAtom);
  const currentBooking = get(currentBookingAtom);

  const bookingDuration = get(getBookingDurationAtom);
  const startSlotId = get(getStartSlotIdFromCourt);

  // if we changed duration or start slot id or rate id, we make it dirty (based on bucket)
  if (
    (bookingDuration && bookingDuration !== originalBooking?.durationMins) ||
    (startSlotId && startSlotId !== originalBooking?.startSlotId) ||
    (currentBooking?.rateId &&
      currentBooking?.rateId !== originalBooking?.rateId)
  ) {
    return true;
  }

  return !isEqual(originalBooking, currentBooking);
});
